import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ClassicGameBoard from "./components/gameboard/ClassicGameBoard";
import CustomGameBoard from "./components/gameboard/CustomGameBoard";
import agent from "../api/agent";
import CenteredCard from "../layout/CenteredCard";

export default function GameBoard() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const gameTypeParam = searchParams.get("gameType");
  const [resolvedGameType, setResolvedGameType] = useState<number | null>(
    gameTypeParam ? parseInt(gameTypeParam, 10) : null
  );
  const [isResolvingGameType, setIsResolvingGameType] = useState(!gameTypeParam);

  useEffect(() => {
    if (gameTypeParam) {
      setResolvedGameType(parseInt(gameTypeParam, 10));
      setIsResolvingGameType(false);
      return;
    }

    if (!id) {
      setResolvedGameType(1);
      setIsResolvingGameType(false);
      return;
    }

    setIsResolvingGameType(true);
    agent.Campaigns.details(id)
      .then((campaign) => {
        setResolvedGameType(campaign.gameType || 1);
      })
      .catch((error) => {
        console.error("Failed to resolve campaign game type:", error);
        setResolvedGameType(1);
      })
      .finally(() => {
        setIsResolvingGameType(false);
      });
  }, [gameTypeParam, id]);

  if (isResolvingGameType) {
    return <CenteredCard>Yükleniyor...</CenteredCard>;
  }

  switch (resolvedGameType) {
    case 4:
      return <CustomGameBoard />;
    default:
      return <ClassicGameBoard />;
  }
}
